import { render, staticRenderFns } from "./bear_content.vue?vue&type=template&id=4a8140f2&scoped=true&"
import script from "./bear_content.vue?vue&type=script&lang=js&"
export * from "./bear_content.vue?vue&type=script&lang=js&"
import style0 from "./bear_content.vue?vue&type=style&index=0&id=4a8140f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8140f2",
  null
  
)

export default component.exports